<mat-card class="cardWithShadow" *ngIf="currentInfo">
    <mat-card-content>
        <div class="container">
            <div class="profile-header">
                <img src="{{currentInfo.logo}}" alt="{{currentInfo.name}}" *ngIf="currentInfo.logo">
                <img src="../../../../assets/images/avatar-placeholder.png" alt="{{currentInfo.name}}"
                    *ngIf="!currentInfo.logo">
                <h3>{{currentInfo.name}}</h3>
            </div>

            <div class="info">
                <h4>{{ 'ContactInformation' | translate }}</h4>
                <p><mat-label class="spanTitle">{{ 'Phone' | translate }}</mat-label> : {{currentInfo.phone}}</p>
                <p><mat-label class="spanTitle">{{ 'Email' | translate }}</mat-label> : {{currentInfo.email}}</p>
                <p><mat-label class="spanTitle">{{ 'Address' | translate }}</mat-label> :
                    {{currentInfo.address}}
                </p>
            </div>

            <mat-divider></mat-divider>

            <div class="row m-t-24 text-center" *ngIf="ShowButns">
                <div class="col-sm-12">
                    <a (click)="ChangePassWord()" class="blueBtn">
                        {{ 'ChangePassWord' | translate}}
                    </a>

                    <a [routerLink]="['/dashboard/edit-info']" class="orangbtn">
                        {{ 'EditInfo' | translate}}
                    </a>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>